import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { StateAccessCheckService } from '../../shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '../../shared/types';
import { FiLoginReminderEditComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-edit/fi-login-reminder-edit.component';
import { FiLoginReminderService } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder.service';
import { FiLoginReminderNavigationTabsComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-navigation-tabs/fi-login-reminder-navigation-tabs.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiLoginReminderOverviewComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-overview/fi-login-reminder-overview.component';
import { FiLoginReminderLogComponent } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-log/fi-login-reminder-log.component';

const loginReminderResolveFn = [
    FiStateService,
    Transition,
    FiLoginReminderService,
    (fiStateService: FiStateService, tr: Transition, loginReminderService: FiLoginReminderService) => {
        return new Promise((resolve, reject) => {
            // get login reminder from state
            const loginReminder = fiStateService.getParams(tr).loginReminder;
            if (loginReminder) {
                resolve(loginReminder);
            } else {
                loginReminderService.getLoginReminder().then(resolve, reject);
            }
        });
    },
];

const LoginReminderState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.LoginReminder._name,
    url: '/LoginReminder',
    views: {
        '@': {
            component: FiLoginReminderNavigationTabsComponent,
        },
    },
    resolve: {
        loginReminder: loginReminderResolveFn,
    },
};

const LoginReminderEditState = {
    name: FiStateNames.OtherSettings.LoginReminder.Edit,
    url: '/Edit',
    params: {
        loginReminder: null,
    },
    component: FiLoginReminderEditComponent,
    resolve: {
        loginReminder: loginReminderResolveFn,
    },
};

const LoginReminderOverviewState = {
    name: FiStateNames.OtherSettings.LoginReminder.Overview,
    url: '/Overview',
    params: {
        loginReminder: null,
    },
    component: FiLoginReminderOverviewComponent,
    resolve: {
        loginReminder: loginReminderResolveFn,
    },
};

const LoginReminderLogState = {
    name: FiStateNames.OtherSettings.LoginReminder.Log,
    url: "/Log?:sortColumn&:sortDirection&:offset'",
    reloadOnSearch: false,
    params: {
        loginReminder: null,
    },
    component: FiLoginReminderLogComponent,
    resolve: {
        loginReminder: loginReminderResolveFn,
        sentOverview: [
            FiLoginReminderService,
            (loginReminderService: FiLoginReminderService) => loginReminderService.getLoginReminderSentOverview(),
        ],
    },
};

export const LoginReminderStates: StatesModule = {
    states: [LoginReminderState, LoginReminderEditState, LoginReminderOverviewState, LoginReminderLogState],
};

export function registerLoginReminderStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.LoginReminder._name], {
        SettingType: [ApplicationSettingsType.LoginReminder],
        AccessType: AccessRightType.Admin,
    });
}
